import {
  type NavLinkProps,
  NavLink as ReactDomNavLink,
} from 'react-router-dom';

export const NavLink = (
  props: NavLinkProps & { ref?: React.Ref<HTMLAnchorElement> },
) => <ReactDomNavLink {...props} />;
